"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Channel = void 0;
var Channel;
(function (Channel) {
    Channel["INBOUND_CALL"] = "inbound_call";
    Channel["OUTBOUND_CALL"] = "outbound_call";
    Channel["WALK_IN"] = "walk_in";
    Channel["OPD_CAMP"] = "opd_camp";
    Channel["ONLINE"] = "online";
    Channel["OUTLET"] = "outlet";
})(Channel || (exports.Channel = Channel = {}));
